<template>
    <div v-if="visible">
        <el-dialog title="选择人员" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose"  width="750px">    
             
            <div style="text-align: center">
                <tree-transfer
                    :titleLeft="titleLeft"
                    :titleRight="titleRight"
                    :data_left="transferData_left_area"
                    :data_right="transferData_right_area"
                    :showFilter="showFilter"
                    :showAllCheck="showAllCheck"
                    :disabled="disabled"
                    @listenRightTreeInfoEvent="bindRightTreeInfoEvent"
                    @listenLeftTreeInfoEvent="bindLeftTreeInfoEvent"
                    ></tree-transfer>
            </div>
             
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../../common/http';
  import treeTransfer  from './treeTransfer/tree-transfer'

  export default {
    components:{treeTransfer},
    data () {
      return {
        visible: false,
        disabled:false,
        titleLeft: '人员数据源', //左侧显示标题
        titleRight: '已选中人员',//右侧选择标题
        transferData_left_area:[],//左侧选择数据
        transferData_right_area:[],//右侧选择数据
        showFilter:true,//是否显示模糊查询
        showAllCheck:true, //是否可全选
        personType:"", // 人员类型（1-学生，2-教职）
        selectType:"",// 选择人员（1-单选，2-多选）
        classId:"",// 班级ID，支持多个
        groupSchemeId:"",// 分组方案ID
        userId:"",// 操作人员ID
        userData:[]
      }
    },
    methods:{
      init(personType,data,selectType,classId,userId, groupSchemeId){
          // 过滤重复的ID
          let dataArr=new Array();
          if(data!=null && data.length>0){
            for(let i=0;i<data.length;i++){
              if(dataArr.indexOf(data[i]) == -1){
                dataArr.push(data[i]);
              }
            }
          }

          this.visible=true;
          this.personType=personType;
          this.userData=dataArr;
          this.selectType=selectType;
          this.classId=classId;
          this.groupSchemeId = groupSchemeId;
          this.userId=userId;
          this.transferData_right_area=[];
          // 获取人员数据
          this.getPersonnel();
      },
      dialogClose(done){
        done();
        this.$reload;
      },
      bindRightTreeInfoEvent:function(data){
        this.transferData_right_area = data;
      },
      bindLeftTreeInfoEvent:function(data){
        this.transferData_left_area = data;
      },
      selectTransfer(){
        if(this.userData!=null && this.userData.length>0){
          //声明选中数据jsonObject
          let selectJsonArr=[];
          let selectSubJsonArr=[];
          for(let j=0;j<this.userData.length;j++){
            //获取完整的JSON
            let selectSubJsonObject={};
            for(let i=0;i<this.transferData_left_area.length;i++){
                let children=this.transferData_left_area[i].children;
                for(let n=0;n<children.length;n++){
                  if(this.userData[j] == children[n].id){
                    selectSubJsonObject=children[n];
                    selectSubJsonArr.push(selectSubJsonObject);
                    break;
                  }
                }
            }
            if(selectSubJsonObject.id == undefined || selectSubJsonObject.id == ''){
              continue;
            }
            //获取父级JSON
            let selectFatherJsonObject={};
            for(let i=0;i<this.transferData_left_area.length;i++){
               let val=this.transferData_left_area[i];
               if(val.id == selectSubJsonObject.parent){
                    selectFatherJsonObject.id=val.id;
                    selectFatherJsonObject.name=val.name;
                    break;
               } 
            }
            if(selectFatherJsonObject.id == undefined || selectFatherJsonObject.id == ''){
              continue;
            }
            // console.log("已选中子级数据："+JSON.stringify(selectSubJsonObject));
            // console.log("已选中父级数据:"+JSON.stringify(selectFatherJsonObject));
            //数据不存在新增，如果存在则新增子级数据
            let isExist=false;
            for(let i=0;i<selectJsonArr.length;i++){
              if(selectJsonArr[i].id == selectFatherJsonObject.id){
                  let children=selectJsonArr[i].children;
                  children.push(selectSubJsonObject);
                  selectJsonArr[i].children=children;
                  isExist=true;
                  break;
              }
              
            }

            if(!isExist){
              let children=new Array();
              children.push(selectSubJsonObject);
              let selectData=selectFatherJsonObject;
              selectData.children=children;
              selectJsonArr.push(selectData);
            }

          }

          //初始选中值，去除左边
          for(let i=0;i<this.transferData_left_area.length;i++){
              let children=this.transferData_left_area[i].children;
              for(let j=0;j<children.length;j++){
                  let isExist=false;
                  for(let n=0;n<selectSubJsonArr.length;n++){
                     if(children[j].id == selectSubJsonArr[n].id){
                          isExist=true;
                          break;
                     }
                  }

                  if(isExist){
                      children.splice(j,1);
                      j--;
                      continue;
                  }
              }
          }
          //遍历
          this.bindRightTreeInfoEvent(selectJsonArr);
        }
      },
      //获取人员数据
      getPersonnel(){
          // 数据还原
          this.transferData_left_area = [];

          let url  = this.listPCUser;
          let data = {
              personType:this.personType,
              classId:this.classId,
              userId:this.userId,
              groupSchemeId:this.groupSchemeId
          };
          this.apiPost(url,data).then((res) => {
              // console.log("人员列表:"+JSON.stringify(res.data))
              if(res.status==200){
                this.transferData_left_area = res.data; 
                this.selectTransfer();
              }else{
                  this.$commonFn.showTip(res.message,3);
              }
          },(err)=>{
              console.log(err);
          });
      },
      save(){
          // 选中id
          let selectKeyArry=new Array();
          // 选中人名
          let selectNameArry=new Array();
          for(let i=0;i<this.transferData_right_area.length;i++){
               // 获取选中人员
               let children=this.transferData_right_area[i].children;
               for(let j=0;j<children.length;j++){
                  selectKeyArry.push(children[j].id);
                  selectNameArry.push(children[j].name);
               }
          }
          
          //重新赋值
          if(this.selectType == 1){
            if(selectKeyArry.length > 1){
                this.$commonFn.showTip("人员只允许选中一个",3);
                return;
            }
            if(selectKeyArry.length == 1){
              this.$parent.setUser(selectKeyArry[0], selectNameArry[0]);
            }else{
              this.$parent.setUser('', '');
            }
          }else if(this.selectType == 2){
            this.$parent.setUser(selectKeyArry,selectNameArry);
          }
          this.visible = false;
      }
    },
    mounted() { 
      //初始值
    },
    mixins: [http]
  }
</script>

<style >
h1, h2 {
  font-weight: normal;
}
.el-transfer-panel .el-transfer-panel__header {
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/page/set/classroomtime/group/UserTransfer.vue